module.exports = __webpack_public_path__ + "img/10008.b01e3d14.jpg";